/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Form, FormText, UncontrolledAlert as Alert } from 'reactstrap';
import { NOTES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import SubmitButton from '#components/pages/Models/Model/sections/support/buttons/ModelFormSectionSubmitButton/index.jsx';
import ContinueToNextSectionGroupButton from '#components/pages/Models/Model/sections/support/buttons/ContinueToNextSectionGroupButton/index.jsx';
import {
  Field,
  FormGroup,
  Fieldset,
  FormGroupCol,
} from '#components/pages/Models/Model/support/form/index.js';
import { notes } from './index.module.scss';

type Props = {|
  error: string,
  fieldsByName: Object,
  group: string,
  groupIsLast: boolean,
  handleSubmit: Function,
  heading: string,
  modelId: string,
  modelType: number,
  onBack: Function,
  onNext: Function,
  submitting: boolean,
|};

const AdditionalNotesSection = (props: Props): Element<'div'> => {
  const {
    error,
    fieldsByName,
    group,
    groupIsLast,
    handleSubmit,
    heading,
    modelId,
    modelType,
    onBack,
    onNext,
    submitting,
  } = props;
  return (
    <div>
      <h2>{heading}</h2>
      <Form noValidate onSubmit={handleSubmit}>
        <Fieldset>
          <legend>Model Notes</legend>
          <FormGroup row>
            <FormGroupCol>
              Provide any notes/comments about your model that you wish to capture.
              <Field field={fieldsByName[NOTES]} excludeLabel rows="8" inputClassName={notes} />
              <FormText color="muted">(These will be included in your PDF report)</FormText>
            </FormGroupCol>
          </FormGroup>
        </Fieldset>
        {error && !submitting ? <Alert color="danger">{error}</Alert> : ''}
        <BackButton onClick={onBack} />
        <SubmitButton modelType={modelType} modelId={modelId} />
        {!groupIsLast && (
          <ContinueToNextSectionGroupButton group={group} modelType={modelType} onClick={onNext} />
        )}
      </Form>
    </div>
  );
};

export default AdditionalNotesSection;
